module.exports = __webpack_public_path__ + "static/img/about-image.3303b0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-image.jpg
// module id = 61
// module chunks = 20